import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { RootState } from "../../store/store"
import { API_SBP_QRC_URL } from "../constants"
import { axios } from "../axios"
import { IQrcInfo } from "../interface"
import { checkIsNotFound } from "../utils/utils"

const getQrcInfo = async (qrcId: string, token: string | null) => {
  const response = await axios(`${API_SBP_QRC_URL}/${qrcId}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })

  if (checkIsNotFound(response.status)) {
    throw new AxiosError(
      `Ошибка загрузки QR-кода: ${response.status}`,
      undefined,
      response.config,
      response.request,
      response,
    )
  }

  return response.data
}

export const useQrcInfo = (qrcId: string | undefined) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IQrcInfo, AxiosError>({
    queryKey: ["qrc-info", qrcId],
    queryFn: () => getQrcInfo(qrcId!, token),
    enabled: Boolean(qrcId) && Boolean(token),
    retry: false,
  })
}
